module.exports = __webpack_public_path__ + "static/media/08.b36a3630.png";